export default [
  {
    id: 'main',
    items: [

      {
        id: 'snapshot',
        url: require('assets/ui/snapshot.txt'),
      },
      {
        id: 'bgm',
        url: require('assets/ui/bgm.txt'),
      },
      {
        id: 'transbgm',
        url: require('assets/ui/transbgm.txt'),
      },
      {
        id: 'scene1kids',
        url: require('assets/scenes/scene1kids.txt'),
      },
      {
        id: 'scene2kids',
        url: require('assets/scenes/scene2kids.txt'),
      },
      {
        id: 'scene3kids',
        url: require('assets/scenes/scene3kids.txt'),
      },
      {
        id: 'scene4kids',
        url: require('assets/scenes/scene4kids.txt'),
      },
      {
        id: 'scene5kids',
        url: require('assets/scenes/scene5kids.txt'),
      },
      {
        id: 'scene1adults',
        url: require('assets/scenes/scene1adults.txt'),
      },
      {
        id: 'scene2adults',
        url: require('assets/scenes/scene2adults.txt'),
      },
      {
        id: 'scene3adults',
        url: require('assets/scenes/scene3adults.txt'),
      },
      {
        id: 'scene4adults',
        url: require('assets/scenes/scene4adults.txt'),
      },
      {
        id: 'scene5adults',
        url: require('assets/scenes/scene5adults.txt'),
      },
    ],
  },
]
